import { type FC } from "react";
import type { TablaGastosProps } from "./types";
import { useTablaGastos } from "./useTablaGastos";

const EMPTY_STATE_COLSPAN = 4;

export const TablaGastos: FC<TablaGastosProps> = (props) => {
  const {
    canLoadMore,
    formatDate,
    formatearNumeros,
    gastos,
    handleLoadMore,
    isLoading,
    isLoadingMore,
  } = useTablaGastos(props);

  return (
    <>
      <h2 className="text-lg text-center font-bold mt-4">Historial de Gastos</h2>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full bg-white">
          <thead>
            <tr className="bg-[#8131bd] text-white">
              <th className="border border-black px-2 py-1">#</th>
              <th className="border border-black px-2 py-1">Valor</th>
              <th className="border border-black px-2 py-1">descripcion</th>
              <th className="border border-black px-2 py-1">fecha</th>
            </tr>
          </thead>
          <tbody>
            {gastos.length > 0 ? (
              gastos.map((item, index) => (
                <tr
                  key={item.id ?? `${item.descripcion ?? "gasto"}-${index}`}
                  className={`${
                    index % 2 === 0 ? "bg-gray-300" : "bg-gray-100"
                  } border border-black font-semibold`}
                >
                  <td className="border text-sm border-black text-center px-2 py-1">{index + 1}</td>
                  <td className="border text-sm border-black text-center px-2 py-1">
                    R${formatearNumeros(Number(item.valor ?? 0))}
                  </td>
                  <td className="border text-sm whitespace-nowrap border-black text-center px-2 py-1">
                    {item.descripcion}
                  </td>
                  <td className="items-center whitespace-nowrap text-sm border-black flex justify-center px-1 py-1">
                    {formatDate(item.fecha)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={EMPTY_STATE_COLSPAN}
                  className="border border-black px-2 py-2 text-center"
                >
                  {isLoading ? "Cargando gastos..." : "No hay datos disponibles."}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {canLoadMore ? (
        <div className="mt-3 flex justify-center">
          <button
            type="button"
            className="bg-[#8131bd] text-white px-3 py-1 rounded-md min-w-[120px]"
            disabled={isLoadingMore}
            onClick={handleLoadMore}
          >
            {isLoadingMore ? "Cargando..." : "Cargar mas"}
          </button>
        </div>
      ) : null}
    </>
  );
};
